var _defs, _path, _rect, _polygon, _polygon2, _polygon3, _polygon4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUvStabilized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.11 174.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#696a6c;}.cls-2{fill:#5a595b;}.cls-3{fill:#4c4847;}.cls-4{fill:#4f4b4a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.15,177.08A87.06,87.06,0,1,1,166.27,48h0A87,87,0,0,1,90.15,177.08ZM89.89,9.92a80.1,80.1,0,1,0,70.25,41.49h0a79.53,79.53,0,0,0-47.86-38.29A80.35,80.35,0,0,0,89.89,9.92Z",
    transform: "translate(-2.94 -2.92)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.37,
    y: 128.29,
    width: 121.14,
    height: 5.01
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.73 101.15 110.72 101.15 110.72 89.89 98.46 89.89 98.46 84.88 115.73 84.88 115.73 101.15"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.48 133.74 26.87 90.13 30.41 86.59 70.48 126.65 110.91 86.23 114.45 89.77 70.48 133.74"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "147.74 101.15 142.74 101.15 142.74 89.89 130.47 89.89 130.47 84.88 147.74 84.88 147.74 101.15"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.49 133.74 58.89 90.13 62.43 86.59 102.49 126.65 142.92 86.23 146.46 89.77 102.49 133.74"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hjRkdf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.78,52.3a16.09,16.09,0,0,1-7.71-10.4c-.43-1.69-1.15-2.1-2.78-2.06-4.14.12-8.29.06-12.43,0-2.25,0-3.47-1-3.48-2.77s1.28-2.81,3.46-2.81q32.7,0,65.39,0c2,0,3.34.68,3.53,2.75.17,1.79-1.25,2.85-3.62,2.86-4.3,0-8.59,0-12.89,0-1.21,0-1.73.33-2,1.53a14.55,14.55,0,0,1-3.72,7.26c-.8,0-1.07.39-1,1.13L101.25,51c-.65-.07-1.06.16-1.11.85a5,5,0,0,1-2.3,1.4c-.28-.45-.58-1.11-1.2-.61-3.17,2.56-6.74,2.18-10.39,1.6C84,53.84,82.12,52.29,79.78,52.3Zm9.7-12.41c-3.52,0-7,0-10.57,0-1.33,0-1.58.4-1.18,1.61,1.51,4.63,6.46,8.12,11.69,8.17a12.67,12.67,0,0,0,12-8.11c.49-1.44,0-1.68-1.34-1.66C96.53,39.93,93,39.89,89.48,39.89Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.87,59.18a3.69,3.69,0,0,1-1.92-.71c-3.31-1.91-6.61-3.84-9.93-5.73-1.67-.94-2.62-2.17-1.66-4.11.82-1.65,2.46-1.91,4.54-.73q5.19,2.94,10.33,6a2.67,2.67,0,0,1,1.38,3.3A2.74,2.74,0,0,1,122.87,59.18Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.16,59.18a2.67,2.67,0,0,1-2.58-1.9,2.56,2.56,0,0,1,1.07-3.22c3.81-2.26,7.62-4.51,11.5-6.64a2.53,2.53,0,0,1,3.45.91c.87,1.21.9,2.67-.3,3.5A118.8,118.8,0,0,1,56.86,59.1,2.17,2.17,0,0,1,56.16,59.18Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.76,69.25c0-2.08,0-4.15,0-6.22,0-1.82.9-3,2.76-3s2.81,1.09,2.82,2.92c0,4.15,0,8.29,0,12.44,0,1.86-1,3-2.76,3s-2.79-1.12-2.83-3C86.74,73.39,86.76,71.32,86.76,69.25Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.29,57.11a2.79,2.79,0,0,1,2-2.64,2.47,2.47,0,0,1,3.06.94c1.93,3.14,3.8,6.31,5.51,9.56a2.5,2.5,0,0,1-1.08,3.41,2.4,2.4,0,0,1-3.5-.51c-2.06-3.22-3.89-6.6-5.79-9.92A2.55,2.55,0,0,1,98.29,57.11Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.87,57.25a7.75,7.75,0,0,1-.45,1.28c-1.67,2.93-3.33,5.87-5.06,8.76-.92,1.54-2.33,2.07-3.92,1.1s-1.74-2.44-.86-4Q73,60.08,75.5,55.83a2.68,2.68,0,0,1,3.32-1.37A2.92,2.92,0,0,1,80.87,57.25Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.78,52.3c2.34,0,4.22,1.54,6.47,1.89,3.65.58,7.22,1,10.39-1.6.62-.5.92.16,1.2.61C91.65,56.37,85.62,56.11,79.78,52.3Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M102.53,49.77c-.09-.74.18-1.16,1-1.13Z",
    transform: "translate(-2.94 -2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.14,51.8c0-.69.46-.92,1.11-.85Z",
    transform: "translate(-2.94 -2.92)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvStabilized);
export default __webpack_public_path__ + "static/media/uv-stabilized.135f4e3195fd5503e50284d7ea1bf9d6.svg";
export { ForwardRef as ReactComponent };